export default {
  VALUE: 'value',
  ACTIVE: 'active',
};
